"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsService = void 0;
const api_1 = require("../api");
function toSearchParams(obj) {
    const search = new URLSearchParams();
    Object.entries(obj).forEach(([key, value]) => {
        if (key !== "id" && value !== undefined) {
            search.set(key, value.toString());
        }
    });
    return search;
}
class AccountsService {
    constructor(fetch) {
        this.apiVersion = api_1.apiVersion;
        this.fetch = fetch;
    }
    /**
     * Get a list of Decodable Accounts of which the authenticated user is a member.
     * @param params.pageSize The maximum number of items to return.
     * @param params.pageToken A token that indicates the page to fetch.
     * @param params.view The amount of data to return for the resource(s).
     *
     * A value of `basic` returns the standard properties of the resource. It may also produce data that is
     * considered "computationally cheap" to return. Specifying `basic` is the same as omitting this parameter.
     *
     * The behavior of `full` is service-dependent, but generally includes more fields. This can mean additional status
     * or version data, or even expanding references to contained resources. This should be used when the cost of an
     * additional API roundtrip is greater than the overhead of the request.
     *
     * @returns any A list of Decodable Accounts.
     * @returns Error An error has occurred.
     * @throws ApiError
     */
    listUserAccounts(params) {
        const { pageSize, pageToken, view } = params;
        return this.fetch(`/${this.apiVersion}/accounts?${toSearchParams({
            pageSize,
            pageToken,
            view,
        })}`);
    }
    /**
     * Create a Decodable Account.
     */
    createAccount(params) {
        const { requestBody: body } = params;
        return this.fetch(`/${this.apiVersion}/accounts`, {
            method: "POST",
            body,
        });
    }
    /**
     * Gets metadata for the account.
     */
    getAccountMetadata() {
        return this.fetch(`/${this.apiVersion}/accounts/metadata`);
    }
    /**
     * Gets information for the account.
     */
    getAccountInformation(params) {
        const { id } = params;
        return this.fetch(`/${this.apiVersion}/accounts/${id}`);
    }
    /**
     * Update a Decodable Account.
     */
    updateAccount(params) {
        const { id } = params, body = __rest(params, ["id"]);
        return this.fetch(`/${this.apiVersion}/accounts/${id}`, {
            method: "PATCH",
            body,
        });
    }
    requestCustomPipelineAccess() {
        return this.fetch(`/${this.apiVersion}/accounts/request-custom-pipeline-access`, {
            method: "POST",
        });
    }
    uploadCertificateSigningRequest(accountName, opts) {
        const formData = new FormData();
        formData.append("file", opts.csr);
        return this.fetch(`/${this.apiVersion}/accounts/${accountName}/certificate_signing_request`, {
            method: "POST",
            body: formData,
        });
    }
    getSignedCertificate(accountName) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fetch(`/${this.apiVersion}/accounts/${accountName}/certificate`, {
                method: "GET",
            });
            const disposition = response.headers.get("Content-Disposition");
            /**
             * Will capture all characters inside the filename quotes.
             * Ex:  'filename="some-file.txt"' -> 'some-file.txt'
             */
            const filenameRegex = /filename="([^"]+)"/;
            const match = disposition.match(filenameRegex);
            return {
                blob: yield response.blob(),
                filename: match ? match[1] : "certificate.pem",
            };
        });
    }
}
exports.AccountsService = AccountsService;
